/** Which warehouse this one restocks from. Saves on change rather than behind a
 *  button — it is a single field with no other state to coordinate. */
import type { Warehouse } from '../../../api/warehouse';

export default function WarehouseRestockSource({
  options,
  selectedId,
  saving,
  onChange,
}: {
  options: Warehouse[];
  selectedId: string | null;
  saving: boolean;
  onChange: (sourceWarehouseId: string | null) => void;
}) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-bark-900 dark:text-stone-100 mb-2">
          Restock Source Warehouse
        </label>
        <select
          value={selectedId || ''}
          onChange={(e) => onChange(e.target.value || null)}
          disabled={saving}
          className="w-full px-3 py-2 border rounded-lg bg-white dark:bg-[#242d28] text-bark-900 dark:text-stone-100 disabled:opacity-50"
        >
          <option value="">No restock source</option>
          {options.map((w) => (
            <option key={w.id} value={w.id}>
              {w.name} {w.code ? `(${w.code})` : ''}
            </option>
          ))}
        </select>
      </div>
      <p className="text-xs text-stone-500 dark:text-stone-400">
        Select which warehouse this location restocks from. A warehouse cannot restock from itself.
      </p>
    </div>
  );
}
